module.exports = __webpack_public_path__ + "static/media/carousel-1.28188d9b.png";